import type { CSSProperties, InputHTMLAttributes, ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export type InputSize = 'sm' | 'md' | 'lg';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'style'> {
  label?: ReactNode;
  icon?: IconName;
  hint?: ReactNode;
  error?: ReactNode;
  size?: InputSize;
  suffix?: ReactNode;
  style?: CSSProperties;
}

const SIZE_MAP: Record<InputSize, { h: number; fs: number }> = {
  sm: { h: 32, fs: 13 },
  md: { h: 38, fs: 14 },
  lg: { h: 44, fs: 15 },
};

export function Input({
  label,
  icon,
  hint,
  error,
  size = 'md',
  suffix,
  style,
  ...rest
}: InputProps) {
  const sz = SIZE_MAP[size];
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }}>
      {label && (
        <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--dg-text-2)' }}>{label}</span>
      )}
      <div
        className={error ? 'dg-input-shell dg-input-error' : 'dg-input-shell'}
        style={{
          height: sz.h,
          paddingLeft: icon ? 10 : 12,
          paddingRight: suffix ? 10 : 12,
        }}
      >
        {icon && (
          <Icon name={icon} size={16} style={{ color: 'var(--dg-text-3)', marginRight: 8 }} />
        )}
        <input
          {...rest}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontSize: sz.fs,
            color: 'var(--dg-text-1)',
            height: '100%',
            minWidth: 0,
          }}
        />
        {suffix && (
          <span style={{ fontSize: 13, color: 'var(--dg-text-3)' }}>{suffix}</span>
        )}
      </div>
      {hint && !error && (
        <span style={{ fontSize: 12, color: 'var(--dg-text-3)' }}>{hint}</span>
      )}
      {error && (
        <span style={{ fontSize: 12, color: 'var(--dg-danger)' }}>{error}</span>
      )}
    </label>
  );
}
